module.exports = __webpack_public_path__ + "img/mobile-clouds.e844601d.png";